/* GridSelectComboboxEditor.js */

"use strict";
const ValueBuilder = require("../../ValueBuilder");
const GridBaseComboBoxEditor = require("./GridBaseComboboxEditor");
const ComboBox = require("@gluenetworks/combobox").Single;
const _ = require("lodash");

class GridSelectComboBoxEditor extends GridBaseComboBoxEditor {
    constructor(args) {
        super(args);
        this.parentContainer = args.container;
        // this.keyCaptureList = [ Slick.keyCode.UP, Slick.keyCode.DOWN, Slick.keyCode.ENTER ];
        this.comboBox = new ComboBox();
        this.initialValue = {};
        this.comboBox.setOptions(args.column.options);
        this.field = args.column.field;

        this.parentContainer[0].appendChild(this.comboBox.renderer.rootElement);
        this.grid = args.grid;
        this.cancelChanges = args.cancelChanges;
        this.grid.openingEditor = true;
        this.fcdColumnDef = args.column.fcdColumnDef;
        this.firstLoad = true;
        setTimeout(() => {
            this.grid.openingEditor = false;
        }, 100);
    }

    static Formatter(row, cell, value, columnDef /*, dataContext */) {
        let label = "";
        if (_.isNumber(value) || !_.isEmpty(value)) {
            columnDef.options.forEach((option) => {
                if (_.isEqual(value, option.value)) {
                    label = option.label;
                    return false;
                }
            });
        }
        let displayElem = document.createElement("div");
        displayElem.innerText = label;

        displayElem.classList.add("grid_cell_view");
        let displayinfo = columnDef.fcdColumnDef.displayinfo;
        displayElem.setAttribute("title", displayinfo.tooltip);

        return displayElem.outerHTML;
    }

    _registerListeners() {
        this.comboBox.on("Value", (this._valueChanged = this._valueChanged.bind(this)));
    }

    _unregisterListeners() {
        this.comboBox.removeListener("Value", this._valueChanged);
    }

    destroy() {
        setTimeout(() => {
            this._unregisterListeners();
            this.comboBox.shutdown();
        });
    }

    show() {
        this.comboBox.renderer.rootElement.focus();
        let clickEvent = new Event("click");
        this.comboBox.renderer.rootElement.dispatchEvent(clickEvent);
    }

    hide() {}

    focus() {}

    loadValue(item) {
        let currentProp = item[this.field];
        if (this.firstLoad) {
            if (currentProp) {
                this.selectFields =
                    this.fcdColumnDef.Select.options[currentProp].value["@propertyOrder"];
            }
            this.firstLoad = false;
        } else {
            // Remove the fields from the initial select option
            if (this.selectFields) {
                this.selectFields.forEach((field) => {
                    delete item[field];
                });
            }
            if (currentProp) {
                let selectFcd = _.cloneDeep(this.fcdColumnDef.Select.options[currentProp].value);
                selectFcd["@"] = "@";
                let defaultValue = {};
                ValueBuilder.getJTypeInstanceData(selectFcd, defaultValue);
                Object.assign(item, defaultValue);
            }
        }
        this.initialValue = item[this.field];
        this.comboBox.setValue(item[this.field]);
        this._registerListeners();
    }

    getValue() {
        this.comboBox.getValue();
    }

    setValue(value) {
        this.comboBox.setValue(value);
    }

    serializeValue() {
        return this.comboBox.getValue();
    }

    applyValue(item, state) {
        item[this.field] = state;
        this.initialValue = state;
    }

    isValueChanged() {
        return !_.isEqual(this.comboBox.getValue(), this.initialValue);
    }

    validate() {
        return {
            valid: true,
            msg: null,
        };
    }

    _valueChanged() {
        this.grid.getEditController().commitCurrentEdit();
    }
}

module.exports = GridSelectComboBoxEditor;
